import { useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import axios from "axios";
import Cookies from "js-cookie";
import handleLogout from "../views/Auth/handleLogout";
import { Modal, Button, notification } from "antd";
import { useAuth } from "../context/AuthContext";

function formatTime(seconds) {
	const minutes = Math.floor(seconds / 60);
	const remainingSeconds = seconds % 60;
	return `${minutes.toString().padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
}

export default function Idle() {
	const { isAuthenticated } = useAuth();
	const [openModal, setOpenModal] = useState(false);
	const [remaining, setRemaining] = useState(0);
	const timeout = 600 * 1000; // 10 minut
	const promptBeforeIdle = 120 * 1000; // 2 minuty

	// Funkcja odnawiania sesji
	const renewSession = async () => {
		if (!Cookies.get("mgltoken") || !isAuthenticated) {
			return;
		}

		try {
			const response = await axios.post(
				process.env.REACT_APP_API_URL + "/auth/renew/session",
			);
			Cookies.set("mgltokenprevious", Cookies.get("mgltoken"), {
				expires: 7,
				domain: process.env.REACT_APP_DOMAIN,
			});
			Cookies.set("mgltoken", response.data.token, {
				expires: 7,
				domain: process.env.REACT_APP_DOMAIN,
			});
		} catch (error) {
			notification.error({
				message: "Błąd odnowienia sesji",
				duration: 3,
			});
			handleLogout();
		}
	};

	// Automatyczne odnawianie sesji co 10 minut
	useEffect(() => {
		if (!isAuthenticated) {
			return undefined;
		}

		const interval = setInterval(
			() => {
				renewSession();
			},
			10 * 60 * 1000,
		);
		return () => clearInterval(interval);
	}, [isAuthenticated]);

	const onIdle = () => {
		if (!isAuthenticated) {
			return;
		}

		handleLogout();
		setOpenModal(false);
	};

	const onPrompt = () => {
		if (!isAuthenticated) {
			return;
		}

		setOpenModal(true);
	};

	const { getRemainingTime, activate } = useIdleTimer({
		onIdle,
		onPrompt,
		timeout,
		promptBeforeIdle,
		throttle: 500,
	});

	useEffect(() => {
		const interval = setInterval(() => {
			setRemaining(Math.ceil(getRemainingTime() / 1000));
		}, 1000);

		return () => clearInterval(interval);
	}, [getRemainingTime]);

	const handleStillHere = () => {
		activate();
		setOpenModal(false);
	};

	return (
		<Modal
			title="Jesteś nieaktywny!"
			open={openModal}
			onCancel={handleStillHere}
			footer={[
				<Button
					key="continue"
					onClick={handleStillHere}
				>
					Jestem aktywny!
				</Button>,
			]}
		>
			<p>
				Jeżeli nie podejmiesz jakiejkolwiek czynności w ciągu{" "}
				<span style={{ color: "red" }}>{formatTime(remaining)}</span>,
				zostaniesz wylogowany, a Twoje niezapisane postępy zostaną
				utracone!
			</p>
		</Modal>
	);
}
